import { getRetailShopId } from './retailShopChannel'

function normalizeResponseData(responseData) {
	if (!responseData) {
		return {}
	}
	if (responseData.data && typeof responseData.data === 'object' && !Array.isArray(responseData.data)) {
		return responseData.data
	}
	return responseData
}

function mapWriteFlagFromApi(value) {
	return value === 1 || value === '1' ? 'write' : 'no_write'
}

function mapWriteFlagToApi(value) {
	return value === 'write' ? 1 : 0
}

function mapAutoOrderFromApi(value) {
	return value === 1 || value === '1' ? 'auto' : 'manual'
}

function mapAutoOrderToApi(value) {
	return value === 'auto' ? 1 : 0
}

function mapShoeBoxFromApi(value) {
	if (value == null || value === '') {
		return 0
	}
	return Number(value) === 1 ? 1 : 0
}

function mapShoeBoxToApi(value) {
	return Number(value) === 1 ? 1 : 0
}

function mapMandatoryAutoOrderFromApi(value) {
	const num = Number(value)
	if (num === 1) {
		return 'manual'
	}
	if (num === 2) {
		return 'auto'
	}
	return 'manual'
}

function mapMandatoryAutoOrderToApi(value) {
	if (value === 'manual') {
		return 1
	}
	if (value === 'auto') {
		return 2
	}
	return 1
}

const LEGACY_COLOR_TO_API = {
	green: 3,
	red: 1,
	yellow: 2,
	blue: 4,
	purple: 5,
}

function mapColorFromApi(value) {
	var num = Number(value)
	if (num >= 1 && num <= 5) {
		return num
	}
	return 3
}

function mapColorToApi(value) {
	if (value != null && LEGACY_COLOR_TO_API[value] != null) {
		return LEGACY_COLOR_TO_API[value]
	}
	var num = Number(value)
	if (num >= 1 && num <= 5) {
		return num
	}
	return 3
}

function mapReturnPolicyFilterFromApi(value) {
	const num = Number(value)
	if (num === 1) {
		return 'exclude0_100'
	}
	if (num === 2) {
		return 'only100_0'
	}
	return 'all'
}

function mapReturnPolicyFilterToApi(value) {
	if (value === 'exclude0_100') {
		return 1
	}
	if (value === 'only100_0') {
		return 2
	}
	return 0
}

function toNumber(value, fallback) {
	if (value == null || value === '') {
		return fallback
	}
	return Number(value)
}

export function mapOrderMatchRuleToForm(data) {
	const src = normalizeResponseData(data)

	return {
		autoOrder: mapAutoOrderFromApi(src.auto_order_enabled),
		noAutoOrderQty: toNumber(src.auto_order_max_items, undefined),
		autoOrderDelay: toNumber(src.auto_order_delay_minutes, undefined),
		autoOrderDeadline: toNumber(src.auto_order_deadline_days, undefined),
		pddNoteTo1889: mapWriteFlagFromApi(src.write_pdd_seller_remark),
		order1889Note: src.order_remark != null ? String(src.order_remark) : '',
		returnPolicyToNote: mapWriteFlagFromApi(src.write_channel_return_policy),
		channelPriceToNote: mapWriteFlagFromApi(src.write_channel_order_price),
		order1889NoToNote: mapWriteFlagFromApi(src.write_order_no_1889),
		securityToNote: mapWriteFlagFromApi(src.write_anti_fake),
		shipDateToNote: mapWriteFlagFromApi(src.write_pre_delivery_date),
		shoeBoxExpress: mapShoeBoxFromApi(src.shoe_box_priority),
		mandatoryAutoOrder: mapMandatoryAutoOrderFromApi(src.required_channel_auto_order),
		mandatoryOrderColor: mapColorFromApi(src.required_channel_color_flag),
		mandatorySellerNote: src.required_channel_seller_remark != null ? String(src.required_channel_seller_remark) : '',
		optionalReturnPolicy: mapReturnPolicyFilterFromApi(src.return_policy_filter),
		profitThreshold: toNumber(src.min_profit_yuan, undefined),
		optionalOrderColor: mapColorFromApi(src.optional_channel_color_flag),
		optionalSellerNote: src.optional_channel_seller_remark != null ? String(src.optional_channel_seller_remark) : '',
	}
}

export function buildOrderMatchRuleSavePayload(retailShopId, form) {
	return {
		retail_shop_id: Number(retailShopId),
		data: {
			auto_order_enabled: mapAutoOrderToApi(form.autoOrder),
			auto_order_max_items: Number(form.noAutoOrderQty),
			auto_order_delay_minutes: Number(form.autoOrderDelay),
			auto_order_deadline_days: Number(form.autoOrderDeadline),
			write_pdd_seller_remark: mapWriteFlagToApi(form.pddNoteTo1889),
			order_remark: form.order1889Note || '',
			write_channel_return_policy: mapWriteFlagToApi(form.returnPolicyToNote),
			write_channel_order_price: mapWriteFlagToApi(form.channelPriceToNote),
			write_order_no_1889: mapWriteFlagToApi(form.order1889NoToNote),
			write_anti_fake: mapWriteFlagToApi(form.securityToNote),
			write_pre_delivery_date: mapWriteFlagToApi(form.shipDateToNote),
			shoe_box_priority: mapShoeBoxToApi(form.shoeBoxExpress),
			required_channel_auto_order: mapMandatoryAutoOrderToApi(form.mandatoryAutoOrder),
			required_channel_color_flag: mapColorToApi(form.mandatoryOrderColor),
			required_channel_seller_remark: form.mandatorySellerNote || '',
			return_policy_filter: mapReturnPolicyFilterToApi(form.optionalReturnPolicy),
			min_profit_yuan: Number(form.profitThreshold),
			optional_channel_color_flag: mapColorToApi(form.optionalOrderColor),
			optional_channel_seller_remark: form.optionalSellerNote || '',
		},
	}
}

export function fetchOrderMatchRule(axios, retailShopId) {
	return axios.post('api/retail_shop/order_match_rule_get', {
		retail_shop_id: retailShopId,
	}).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '获取订单自动匹配渠道规则失败')
		}
		return normalizeResponseData(res.data.data)
	})
}

export function saveOrderMatchRule(axios, payload) {
	return axios.post('api/retail_shop/order_match_rule_save', payload).then(function(res) {
		if (res.data.code != 0) {
			throw new Error(res.data.message || '保存失败')
		}
		return res.data
	})
}

export { getRetailShopId }



// WEBPACK FOOTER //
// ./src/components/StoreConfig/detailed/retailShopOrderMatchRule.js